import React from 'react';
import { StandardFonts } from 'pdf-lib';
import { Form, Select } from 'antd';
import {
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
} from '@ant-design/icons';

import OnTraccrNumberInput from '../../inputs/OnTraccrNumberInput';

import PDFDesignerColorPicker from './PDFDesignerColorPicker';
import PDFDesignerAlignmentPicker from './PDFDesignerAlignmentPicker';
import PDFDesignerFontScalingMode from './PDFDesignerFontScalingMode';

import { SUPPORTED_FONTS, STANDARD_PDF_FONTS } from './PDFDesigner.constants';
import { getPopupContainer } from '../pdfHelpers';

const formStyle = { marginBottom: 5 };

export default function PDFDesignerFontPicker({
  onDrawOptionChanged,
  drawOptions: {
    fontFamily,
    fontSize,
    color,
    textAlign,
    growToFitText, // Either grow the bounds to fit text or shrink text to fit bounds
  } = {},
  showFontScaleSelector
}) {
  return (
    <>
      <Form.Item
        name="font"
        key="font"
        label="Font"
        style={formStyle}
      >
        <Select
          onSelect={(newFontFamily) => onDrawOptionChanged({ fontFamily: newFontFamily })}
          defaultValue={fontFamily}
          getPopupContainer={getPopupContainer}
        >
          {
            Object.keys(SUPPORTED_FONTS).map((fontKey) => {
              const fontValue = SUPPORTED_FONTS[fontKey];
              // For standard fonts, use StandardFonts mapping
              // For custom fonts, use the font name directly
              const displayName = STANDARD_PDF_FONTS.includes(fontKey) && StandardFonts[fontKey]
                ? StandardFonts[fontKey]
                : fontValue;

              return (
                <Select.Option
                  key={fontKey}
                  value={fontValue}
                >
                  <span style={{ fontFamily: fontValue }}>{displayName}</span>
                </Select.Option>
              );
            })
          }
        </Select>
      </Form.Item>
      <Form.Item
        name="fontSize"
        key="fontSize"
        label="Font Size"
        style={formStyle}
      >
        <OnTraccrNumberInput
          style={{ width: '100%' }}
          min={4}
          max={64}
          defaultValue={fontSize}
          onChange={(newFontSize) => onDrawOptionChanged({ fontSize: newFontSize })}
        />
      </Form.Item>
      {
        showFontScaleSelector &&
        <PDFDesignerFontScalingMode
          growToFitText={growToFitText}
          onChange={(newGrowToFit) => onDrawOptionChanged({ growToFitText: newGrowToFit })}
        />
      }
      <PDFDesignerColorPicker
        style={formStyle}
        title="Color"
        value={color}
        onColorChanged={(newColor) => onDrawOptionChanged({ color: newColor })}
      />
      <PDFDesignerAlignmentPicker
        title="Horizontal Alignment"
        value={textAlign}
        onAlignmentChanged={(newAlignment) => onDrawOptionChanged({ textAlign: newAlignment })}
        alignments={[
          { alignment: 'left', Icon: AlignLeftOutlined },
          { alignment: 'center', Icon: AlignCenterOutlined },
          { alignment: 'right', Icon: AlignRightOutlined },
        ]}
        style={formStyle}
      />
    </>
  );
}
